import { render, staticRenderFns } from "./TerminalGame.vue?vue&type=template&id=311558ca&scoped=true&"
import script from "./TerminalGame.vue?vue&type=script&lang=js&"
export * from "./TerminalGame.vue?vue&type=script&lang=js&"
import style0 from "./TerminalGame.vue?vue&type=style&index=0&id=311558ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311558ca",
  null
  
)

export default component.exports